import Vue from 'vue';
import Echarts from 'vue-echarts';

import 'echarts/lib/chart/line';
import "@vue/composition-api";
import 'echarts/lib/component/graphic';
import 'echarts/lib/component/tooltip';
import 'echarts';

Vue.component('Chart', Echarts);